<div fxLayout="column" fxLayoutAlign="space-evenly stretch" style="margin:5px">

  <kendo-grid
    [kendoGridBinding]="gridData"
    [kendoGridSelectBy]="selectedCallback"
    [selectedKeys]="mySelection"
    [filterable]="true"
    [resizable]="true"
    [sortable]="true"
    [scrollable]="true"
    [pageSize]="20"
    [pageable]="{
                  buttonCount: 5,
                  info: true,
                  type: 'numeric',
                  pageSizes: [20, 40, 60],
                  previousNext: true
                 }"
    style="height: 70vh">

    <kendo-grid-column field="statusInText" title="Status" filterable="true" [width]="150"></kendo-grid-column>
    <kendo-grid-column field="itemNum" title="Item" filterable="true" [width]="150"></kendo-grid-column>
    <kendo-grid-column field="itemDesc" title="Description" filterable="true" [width]="150"></kendo-grid-column>
    <kendo-grid-column field="pckSize" title="Pack Size" filterable="true" [width]="150"></kendo-grid-column>
    <kendo-grid-column field="purchaseUOM" title="Pack UOM" filterable="true" [width]="150"></kendo-grid-column>
  </kendo-grid>

  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="end stretch" style="margin-top: 10px">

    <app-mcl-button text="Back" primary="true" (click)="back()">
    </app-mcl-button>
  </div>

</div>

<div kendoDialogContainer></div>

